import { useEffect, useState } from "react";
import { CalendarCheck, Video } from "lucide-react";
import { PageBody, PageHeader, EmptyState } from "@/components/Page";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

export default function Meetings() {
  const [meetings, setMeetings] = useState([]);
  useEffect(() => { api.get("/meetings").then((r) => setMeetings(r.data)).catch(() => {}); }, []);

  return (
    <PageBody>
      <PageHeader eyebrow="Meetings" title="Booked conversations"
        subtitle="Positive replies convert to meetings with a booking path. Cal.com / Calendly connect in Phase 2." />
      {meetings.length === 0 ? (
        <EmptyState icon={CalendarCheck} title="No meetings booked yet" body="Book meetings from positive replies in the inbox." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="meetings-grid">
          {meetings.map((m) => (
            <div key={m.id} className="rounded-xl border border-border/70 bg-card/50 p-5" data-testid={`meeting-card-${m.id}`}>
              <div className="flex items-center justify-between mb-3">
                <Video className="h-5 w-5 text-amber-500" />
                <Badge variant="outline" className="capitalize text-xs">{m.status}</Badge>
              </div>
              <div className="font-medium">{m.contact_name}</div>
              <div className="text-xs text-muted-foreground">{m.contact_company}</div>
              <div className="text-xs font-mono text-muted-foreground mt-3">{new Date(m.scheduled_for).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}</div>
            </div>
          ))}
        </div>
      )}
    </PageBody>
  );
}
